import React, { useState, useEffect } from 'react'

// Deps
import { connect } from 'react-redux';

// Partials
import Collapser from 'views/shared/partials/collapser'
import Link from 'views/shared/partials/link'

const mapStateToProps = (state, ownProps) => {
	return {
		currentPage: state.site.currentPage,
		userData: state.user.data,
		userGroups: state.user.groups,
	};
};

const Onboarding = ({userData, userGroups, ...props}) => {
	const [issues, setIssues] = useState([]); 

	useEffect(() => {
		if(userData && userGroups) {
			let newIssues = [];
			if(!userGroups.length) {
				newIssues.push('groups');
			}

			if(!(
				userData.company.phone_number &&
				userData.company.name &&
				userData.company.tax_office &&
				userData.company.invoice_address &&
				userData.company.invoice_name &&
				userData.company.tax_number
			)) {
				newIssues.push('userData');
			}

			setIssues(newIssues);
		}
	}, [userData, userGroups])

	if(issues.length) {
		return (
			<section className="section onboarding portlet yellow">
				<div className="portlet-header small">
					<strong className="portlet-title">
						Ödedim'e hoş geldin {userData.name} {userData.surname}. İşte Ödedim'i kullanmaya başlamak için yapman gerekenler:
					</strong>
				</div>
				<div className="portlet-section bottom onboarding-todo">
					{issues.includes('userData') &&
						<Collapser
							className="todo-item"
							title={<><i className="icon-payment"></i> Firma bilgilerini doldur.</>}>
							Ödeme almaya başlamak için firma bilgilerini eksiksiz bir şekilde doldurmalısın. <Link href="settings.companyInfo">Firma Bilgileri Sayfasına Git</Link>.
						</Collapser>
					}
					{issues.includes('groups') &&
						<Collapser
							className="todo-item"
							title={<><i className="icon-users"></i> Ödeme grubu oluştur.</>}>
							Ödeme almaya başlamak için en az bir ödeme grubu oluşturmalısın. <Link href="settings.groups">Gruplar Sayfasına Git</Link>.
						</Collapser>
					}
				</div>
			</section>
		)
	}
	else { return false; }
}


export default connect(mapStateToProps)(Onboarding);